export default "__VITE_ASSET__CwYunHTp__"